import {createContext} from "react"

const FacturacionContext = createContext()

export default FacturacionContext;